/* eslint-disable no-useless-escape */
/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

// Bootstrap CSS and components
import "bootstrap/dist/css/bootstrap.min.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// app bar
import Box from "@mui/material/Box";

// ES6 Modules or TypeScript

import CustomTextField from "./TextField";
import CustomTextArea from "./TextArea";
import CustomImageUpload from "./ImageUpload";
import CustomNumberField from "./CustomNumberField"; // Add import for the new CustomNumberField component

import MultiSelectWithSearch from "./MultiSelectDropdown";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { ALERT_TITLES, ROUTES, validator } from "../../../constants/index";

import Swal from "sweetalert2";
import { POST } from "../../../services/HTTPServices";
import { LanguageText } from "../../../styles/components";
import {
  injectCustomStyles2,
} from "../../../services/alertService";

import FoodOptionInput from "./foodinput/FoodOptionInput";
import HelpIcon from "@mui/icons-material/Help";

// In AddNewFoodMenu.tsx imports
import {
  FormContainer,
  FormRow,
  FormLabel,
  FormField,
  ProductDivider,
  OptionDivider,
  SendButton,
  SendButtonActive,
  AddSubOptionsButton,
  PriceDisplayBox,
  AddOptionsButton,
  AvailabilityToggleContainer,
  ToggleSwitch,
  ToggleInput,
  ToggleSlider,
  ToggleLabel,
  ReviewModalOverlay,
  ReviewModalContent,
  ReviewModalHeader,
  ReviewModalTitle,
  ReviewModalCloseButton,
  ReviewModalBody,
  ReviewImageContainer,
  ReviewImage,
  ReviewImagePlaceholder,
  ReviewItemDetails,
  ReviewItemName,
  ReviewItemPrice,
  ReviewItemDescription,
  ReviewCategoryTag,
  ReviewOptionsSection,
  ReviewOptionGroup,
  ReviewOptionsTitle,
  ReviewOptionGroupName,
  ReviewOptionGroupOptions,
  ReviewModalActions,
  ReviewModalButton,
  ReviewLoadingSpinner,
  HelpIconContainer,
  HelperTextPopup,
  HelperTextContent,
  TimeInputField,
} from "../../../styles/AddNewFoodMenu.styled";
import { alertMessageWithCancel } from "../../../services/alertService";

import {
  LoadingOverlay,
  LoadingSpinner,
  LoadingSpinnerIcon,
} from "../../../styles/loading";
import { ErrorText } from "../../../styles/PersonalInfoStep";
import {
  PageHeader,
  PageTitle,
  ActionButtons,
  ResponsiveButtonContainer,
} from "../../../styles/AddNewBundleDeal.styled";
import { setItem } from "../../../utils/cache/LocalStorage";
import { useErrorResponse } from "../../../services/useErrorResponse";
import CustomQtyField from "./CustomQtyField";

interface Option {
  name: string;
  qty: number;
  isRequired: number;
  price: number;
  totalPrice: number;
  unit: string;
  isAvailable: boolean;
  photoPath: string;
}

const FoodEntry: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const outErrorResponse = useErrorResponse();

  const merchantId = React.useRef("");

  const maxNumber = 69;

  const [loading, setLoading] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(true);

  const [showReviewModal, setShowReviewModal] = useState(false);
  const [isCreatingFromReview, setIsCreatingFromReview] = useState(false);

  // Helper text state management
  const [helperTextVisible, setHelperTextVisible] = useState<{
    menuAvailable: boolean;
    foodCategory: boolean;
    foodName: boolean;
    foodDescription: boolean;
    foodPrice: boolean;
    preparationTime: boolean;
    eighteenPlus: boolean;
    optionName: boolean;
    optionDescription: boolean;
    minSelection: boolean;
    maxSelection: boolean;
    choiceName: boolean;
    additionalPrice: boolean;
    totalPrice: boolean;
    quantity: boolean;
    unit: boolean;
    image: boolean;
    [key: string]: boolean;
  }>({
    menuAvailable: false,
    foodCategory: false,
    foodName: false,
    foodDescription: false,
    foodPrice: false,
    preparationTime: false,
    eighteenPlus: false,
    optionName: false,
    optionDescription: false,
    minSelection: false,
    maxSelection: false,
    choiceName: false,
    additionalPrice: false,
    totalPrice: false,
    quantity: false,
    unit: false,
    image: false,
  });

  const [product, setProduct] = useState({
    id: "",
    serviceProviderId: "",
    item: "",
    name: "",
    photoPath: "",
    estPreparationTime: "",
    isAvailable: true,
    description: "",
    fullDesc: "",
    price: 0,
    categories: [] as any[],
    isEighteenPlus: false,
    foodOptionsTypeList: [] as {
      id: string;
      menuId: string;
      name: string;
      description: string;
      minCount: number;
      maxCount: number;
      isRequired: boolean;
      isNew?: boolean;
      [key: string]: any;
      foodOptionsList: {
        name: string;
        qty: number;
        isRequired: boolean;
        price: number;
        totalPrice: number;
        unit: string;
        isAvailable: boolean;
        photoPath: string;
        foodOptionsTypeId: string;
        id?: any;
        [key: string]: any;
      }[];
    }[],
  });
  const [images, setImages] = useState([
    {
      id: 1,
      productId: 0,
      photoName: "",
      photoPath: "",
      isDelete: false,
    },
  ]);
  const [categories, setCategories] = useState([]);
  const [submitBtnClick, setSubmitBtnClick] = useState(false);


  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
    if (authUser) {
      merchantId.current = authUser.id;
    }
    if (id !== "-1") {
      getDataCategories("old");
    } else {
      let temp = { ...product };
      temp.serviceProviderId = authUser.id.toString();
      setProduct(temp);
      getDataCategories();
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getProduct = async () => {
    setLoading(true);
    setRefreshFlag(false);
    let url = "fooddelivery/GetFoodMenuDetailsByMenuId";
    let res: any = await POST(url, { menuId: id }, "provider");

    if (res && res.status === 200) {
      setProduct(res.data);
      setImages([
        {
          id: 1,
          productId: 0,
          photoName: "",
          photoPath: res.data.photoPath,
          isDelete: false,
        },
      ]);
      setLoading(false);
      setRefreshFlag(true);
    } else {
      setLoading(false);
      setRefreshFlag(true);
      outErrorResponse(res.status, res.message);
    }
  };

  const addNewFoodOption = () => {
    let temp = { ...product };
    temp.foodOptionsTypeList.push({
      id: temp.foodOptionsTypeList.length.toString(),
      menuId: !temp.id || temp.id === "-1" ? "" : temp.id,
      name: "",
      description: "",
      minCount: 0,
      maxCount: 0,
      isRequired: false,
      isNew: true,

      foodOptionsList: [
        {
          name: "",
          qty: 0,
          isRequired: false,
          price: 0,
          totalPrice: 0,
          unit: "",
          isAvailable: true,
          photoPath: "",
          foodOptionsTypeId: "",
          id: "",
        },
      ],
    });
    setProduct(temp);
  };

  const getDataCategories = async (type = "") => {
    let url = "fooddelivery/GetFoodCategories";

    let res: any = await POST(
      url,
      {
        keyword: "",
        serviceProviderId: "",
      },
      "provider"
    );

    if (res && res.status === 200) {
      if (type === "old") {
        setCategories(res.data.foodCategories);
        getProduct();
      } else {
        setCategories(res.data.foodCategories);
        setLoading(false);
      }
    } else {
      setLoading(false);
      outErrorResponse(res.status, res.message);
    }
  };

  const valueChangedProductPhotos = (value: any) => {
    if (value.type === "401") {
      window.location.replace("/unauthorized-page");
    } else {
      let tempProduct = { ...product };
      tempProduct.photoPath = value.data[0].photoPath;
      setProduct(tempProduct);
      setImages(value.data);
    }
  };

  const checkNotValid = () => {
    const {
      item,
      price,
      photoPath,
      categories,
      foodOptionsTypeList,
      description,
    } = product;

    const isInvalidName = item === "" || item.length > 120;
    const isInvalidDesc = description !== "" && description.length > 300;

    const isInvalidPrice = price <= 0;
    const isPhotoPathEmpty = photoPath === "";
    const isInvalidCat = categories.length <= 0;

    const hasInvalidFoodOptions =
      foodOptionsTypeList.length > 0 &&
      foodOptionsTypeList.some(
        (optionType: any) =>
          optionType.foodOptionsList.some(
            (option: any) => option.name === "" || option.name.length > 150
          ) ||
          optionType.foodOptionsList.length < optionType.maxCount ||
          optionType.minCount < 0 ||
          optionType.maxCount < 0 ||
          (optionType.description !== "" &&
            optionType.description.length > 300) ||
          optionType.minCount > optionType.maxCount ||
          parseInt(optionType.qty) <= 0 ||
          optionType.unit === "" ||
          optionType.name === "" ||
          optionType.name.length > 100
      );
    return (
      isInvalidName ||
      isInvalidDesc ||
      isInvalidPrice ||
      isPhotoPathEmpty ||
      isInvalidCat ||
      hasInvalidFoodOptions
    );
  };

  const submit = async () => {
    setSubmitBtnClick(true);
    const cleanProduct = { ...product };
    if (cleanProduct.foodOptionsTypeList) {
      cleanProduct.foodOptionsTypeList = cleanProduct.foodOptionsTypeList.map(
        (option: any) => {
          const { isNew, ...cleanOption } = option;
          return cleanOption;
        }
      );
    }
    setProduct(cleanProduct);

    if (checkNotValid()) {
    } else {
      setShowReviewModal(true);
    }
  };

  const createFoodMenu = async () => {
    setLoading(true);
    let url =
      id === null || id === "" || id === "-1"
        ? "fooddelivery/CreateMenu"
        : "fooddelivery/UpdateMenu";

    let res: any = await POST(url, product, "provider");

    if (res && res.status === 200) {
      setLoading(false);
      alertMessageCustom(
        "Success!",
        "You " +
          (id === null || id === "" || id === "-1"
            ? "Item created. Pending admin approval."
            : "Item updated."),
        ROUTES.MENU_MANAGEMENT
      );
    } else {
      setLoading(false);
      outErrorResponse(res.status, res.message);
    }
  };

  const alertMessageCustom = (title: string, text: string, route = "") => {
    injectCustomStyles2();
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: title,
        text: text,
        icon:
          title === "Error!"
            ? "error"
            : title === "Success!"
            ? "success"
            : "warning",
        confirmButtonText: "OK",
        reverseButtons: true,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          if (route == ROUTES.MENU_MANAGEMENT) {
            setItem("selected_menu_tab", "food-menu");
            navigate(ROUTES.MENU_MANAGEMENT);
          }
        }
      });
  };

  const cancel = async () => {
    const confirmLeave: any = await alertMessageWithCancel(
      ALERT_TITLES.INFO,
      "Are you sure to cancel your creating or editing food menu?"
    );
    if (confirmLeave) {
      setItem("selected_menu_tab", "food-menu");

      navigate(ROUTES.MENU_MANAGEMENT);
    }
  };

  const sanitizeInput = (input: string): string => {
    return input.replace(/[^a-zA-Z0-9\s\-'",()&\.]/g, "");
  };

  const validateTextInput = (
    input: string,
    _maxLength: number = 120
  ): string => {
    const sanitized = sanitizeInput(input);
    return sanitized;
  };

  // Individual callback functions for better performance
  const callbackOptionName = React.useCallback((value: any, option: any) => {
    setProduct((prevProduct) => {
      const updatedOptionsTypeList = prevProduct.foodOptionsTypeList.map(
        (opt) => {
          if (opt.id === option.id) {
            const processedValue = validateTextInput(value, 100);
            return {
              ...opt,
              name: processedValue,
            };
          }
          return opt;
        }
      );

      return {
        ...prevProduct,
        foodOptionsTypeList: updatedOptionsTypeList,
      };
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const callbackOptionDescription = React.useCallback(
    (value: any, option: any) => {
      setProduct((prevProduct) => {
        const updatedOptionsTypeList = prevProduct.foodOptionsTypeList.map(
          (opt) => {
            if (opt.id === option.id) {
              const processedValue = validateTextInput(value, 300);
              return {
                ...opt,
                description: processedValue,
              };
            }
            return opt;
          }
        );

        return {
          ...prevProduct,
          foodOptionsTypeList: updatedOptionsTypeList,
        };
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const callbackOptionMinCount = React.useCallback(
    (value: any, option: any) => {
      setProduct((prevProduct) => {
        const updatedOptionsTypeList = prevProduct.foodOptionsTypeList.map(
          (opt) => {
            if (opt.id === option.id) {
              const processedValue =
                value === "" || value === null || value === undefined
                  ? 0
                  : parseInt(value);
              return {
                ...opt,
                minCount: processedValue,
              };
            }
            return opt;
          }
        );

        return {
          ...prevProduct,
          foodOptionsTypeList: updatedOptionsTypeList,
        };
      });
    },
    []
  );

  const callbackOptionMaxCount = React.useCallback(
    (value: any, option: any) => {
      setProduct((prevProduct) => {
        const updatedOptionsTypeList = prevProduct.foodOptionsTypeList.map(
          (opt) => {
            if (opt.id === option.id) {
              const processedValue =
                value === "" || value === null || value === undefined
                  ? 0
                  : parseInt(value);

              const updatedOption = {
                ...opt,
                maxCount: processedValue,
              };

              const newMaxCount = processedValue;
              const currentFoodOptions = opt.foodOptionsList || [];

              if (newMaxCount > 0) {
                if (currentFoodOptions.length < newMaxCount) {
                  // Add new empty food options
                  const newFoodOptions = [...currentFoodOptions];
                  for (
                    let i = currentFoodOptions.length;
                    i < newMaxCount;
                    i++
                  ) {
                    newFoodOptions.push({
                      id: "",
                      name: "",
                      price: 0,
                      isNew: true,
                      qty: 0,
                      isRequired: false,
                      totalPrice: 0,
                      unit: "",
                      isAvailable: true,
                      photoPath: "",
                      foodOptionsTypeId: opt.id,
                    });
                  }
                  updatedOption.foodOptionsList = newFoodOptions;
                }
              }

              return updatedOption;
            }
            return opt;
          }
        );

        return {
          ...prevProduct,
          foodOptionsTypeList: updatedOptionsTypeList,
        };
      });
    },
    []
  );

  const deleteOption = (option: any) => {
    alertMessageWithCancelOption(
      "Alert!",
      "Are you sure to delete this food option?",
      option
    );
  };

  const alertMessageWithCancelOption = (
    title: string,
    text: string,
    option: any
  ) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: title,
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then((result: any) => {
        injectCustomStyles2();

        if (result.isConfirmed) {
          let temp = { ...product };
          let ind = temp.foodOptionsTypeList.findIndex(
            (o: any) => o.id == option.id
          );
          if (ind > -1) {
            temp.foodOptionsTypeList.splice(ind, 1);
            setProduct(temp);
          }
        }
      });
  };

  const handleAddFoodOption = (option: any) => {
    let temp = { ...product };
    let ind = temp.foodOptionsTypeList.findIndex((o: any) => o.id == option.id);
    if (ind > -1) {
      const newOption: any = {
        name: "",
        qty: 0,
        isRequired: false,
        price: 0,
        totalPrice: 0,
        unit: "",
        isAvailable: true,
        photoPath: "",
        foodOptionsTypeId: "",
        id: "",
      };

      temp.foodOptionsTypeList[ind].foodOptionsList.push(newOption);
      setProduct(temp);
    }
  };

  const removeOption = (option: any, index: number) => {
    let temp = { ...product };
    let ind = temp.foodOptionsTypeList.findIndex((o: any) => o.id == option.id);
    if (ind > -1) {
      const updatedOptions = [...temp.foodOptionsTypeList[ind].foodOptionsList];
      if (updatedOptions.length > 1) {
        updatedOptions.splice(index, 1);
        temp.foodOptionsTypeList[ind].foodOptionsList = updatedOptions;
        setProduct(temp);
      } else {
        // alertMessage("Warning!", "Food Option must have at least one option.");
      }
    }
  };

  const handleRemoveOption = (option: any, index: number) => {
    alertMessageWithCancelOptionChoice(
      "Alert!",
      "Are you sure to delete this choice?",
      option,
      index
    );
  };

  const alertMessageWithCancelOptionChoice = (
    title: string,
    text: string,
    option: any,
    index: any
  ) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: title,
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then((result: any) => {
        injectCustomStyles2();

        if (result.isConfirmed) {
          removeOption(option, index);
        }
      });
  };

  const handleOptionChange = (
    option: any,
    index: number,
    field: keyof Option,
    value: any
  ) => {
    if (field === "qty" && (value < 0 || !/^\d*\.?\d*$/.test(value))) {
      return;
    } else if (field === "price") {
      let res = /^\d*\.?\d{0,2}$/.test(value);
      if (isNaN(value)) value = 0;
      else {
        if (!res) return;
      }
    }

    // Apply sanitization to name and unit fields
    if (field === "name") {
      value = validateTextInput(value, 150);
    } else if (field === "unit") {
      value = validateTextInput(value, 50);
    }

    if (field === "photoPath") {
      if (value.type === "401") {
        window.location.replace("/unauthorized-page");
        return;
      } else {
        value = value.data[0].photoPath;
      }
    }

    let temp = { ...product };
    let ind = temp.foodOptionsTypeList.findIndex((o: any) => o.id == option.id);
    if (ind > -1) {
      const updatedOptions = [...temp.foodOptionsTypeList[ind].foodOptionsList];
      updatedOptions[index] = { ...updatedOptions[index], [field]: value };
      temp.foodOptionsTypeList[ind].foodOptionsList = updatedOptions;
      setProduct(temp);
    }
  };

  const callbackPrice = (value: any) => {
    if (value === validator.not_valid) {
      setRefreshFlag(false);
      let oldPrice = product.price;
      setProduct((prevState) => ({ ...prevState, price: oldPrice }));
      setRefreshFlag(true);
    } else {
      const valueStr = value.toString();

      if (/\.\d{3,}/.test(valueStr)) {
        return;
      }

      let res = /^\d*\.?\d{0,2}$/.test(valueStr);

      if (valueStr.includes(".")) {
        const decimalPart = valueStr.split(".")[1];
        if (decimalPart && decimalPart.length > 2) {
          return;
        }
      }

      if (isNaN(value)) {
        value = 0;
      } else {
        if (!res) {
          return;
        } else if (res || value === "") {
          let numValue = parseFloat(value) || 0;
          let val = parseFloat(numValue.toFixed(2));
          setProduct((prevState) => ({
            ...prevState,
            price: val || 0,
          }));
        }
      }
    }
  };

  const showMessage = (
    field: any,
    optionIndex?: number,
    choiceIndex?: number
  ) => {
    switch (field) {
      case "description": {
        const { description } = product;

        const isInvalidDescription = description.length > 300;
        return submitBtnClick && isInvalidDescription ? (
          <ErrorText>Description must be less than 300 characters.</ErrorText>
        ) : null;
      }
      case "item": {
        const { item } = product;
        const isInvalidName = item === "" || item.length > 120;
        return submitBtnClick && isInvalidName ? (
          item === "" ? (
            <ErrorText>Please enter item name.</ErrorText>
          ) : (
            <ErrorText>Item Name must be within 120 characters.</ErrorText>
          )
        ) : null;
      }
      case "price": {
        const { price } = product;
        const isInvalidPrice = price <= 0;
        return submitBtnClick && isInvalidPrice ? (
          <ErrorText>Price must be greater than 0.</ErrorText>
        ) : null;
      }
      case "photoPath": {
        const { photoPath } = product;
        const isPhotoPathEmpty = photoPath === "";
        return submitBtnClick && isPhotoPathEmpty ? (
          <ErrorText>Item Photo is mandatory.</ErrorText>
        ) : null;
      }
      case "categories": {
        const { categories } = product;
        const isInvalidCat = categories.length <= 0;
        return submitBtnClick && isInvalidCat ? (
          <ErrorText>At least one category must be selected.</ErrorText>
        ) : null;
      }
      case "optionName": {
        if (optionIndex === undefined) return null;
        const option = product.foodOptionsTypeList[optionIndex];
        const isInvalidName =
          !option || option.name === "" || option.name.length > 100;

        const shouldShowError =
          submitBtnClick && isInvalidName && !option.isNew;

        return shouldShowError ? (
          option.name === "" ? (
            <ErrorText>Option Name is mandatory.</ErrorText>
          ) : (
            <ErrorText>Option Name must be within 100 characters.</ErrorText>
          )
        ) : null;
      }
      case "optionDescription": {
        if (optionIndex === undefined) return null;
        const option = product.foodOptionsTypeList[optionIndex];
        const isInvalidDescription = option.description.length > 300;

        const shouldShowError =
          submitBtnClick && isInvalidDescription && !option.isNew;

        return shouldShowError ? (
          <ErrorText>
            Option Description must be within 300 characters.
          </ErrorText>
        ) : null;
      }

      case "optionMin": {
        if (optionIndex === undefined) return null;
        const option = product.foodOptionsTypeList[optionIndex];
        const isInvalidMin = !option || option.minCount < 0;

        const shouldShowError = submitBtnClick && isInvalidMin && !option.isNew;

        return shouldShowError ? (
          <ErrorText>Please enter a valid Minimum Quantity.</ErrorText>
        ) : null;
      }

      case "optionMax": {
        if (optionIndex === undefined) return null;
        const option = product.foodOptionsTypeList[optionIndex];
        const isInvalidMax = !option || option.maxCount <= 0;

        const shouldShowError = submitBtnClick && isInvalidMax && !option.isNew;

        const shouldShowError2 =
          submitBtnClick &&
          !isInvalidMax &&
          !option.isNew &&
          option.maxCount < option.minCount;

        return shouldShowError ? (
          <ErrorText>Max. Choice must be greater than 0.</ErrorText>
        ) : shouldShowError2 ? (
          <ErrorText>Max. Choice must be greater than Min. Choice.</ErrorText>
        ) : null;
      }

      case "choiceLength": {
        if (optionIndex === undefined) return null;
        const optionType = product.foodOptionsTypeList[optionIndex];
        const isInvalidChoiceLength =
          optionType.foodOptionsList.length < optionType.maxCount;

        const shouldShowError =
          submitBtnClick && isInvalidChoiceLength && !optionType.isNew;

        return shouldShowError ? (
          <ErrorText marginBottom="8px">
            Number of choices must be at least equal to Max Choice.
          </ErrorText>
        ) : null;
      }

      case "choiceName": {
        if (optionIndex === undefined || choiceIndex === undefined) return null;
        const option = product.foodOptionsTypeList[optionIndex];
        const choice = option?.foodOptionsList[choiceIndex];
        const isInvalidChoice =
          !choice || choice.name === "" || choice.name.length > 150;

        const shouldShowError =
          submitBtnClick && isInvalidChoice && !option.isNew;

        return shouldShowError ? (
          choice.name === "" ? (
            <ErrorText>Choice Name is mandatory.</ErrorText>
          ) : (
            <ErrorText>Choice Name must be within 150 characters.</ErrorText>
          )
        ) : null;
      }

      case "choiceAdditionalprice": {
        if (optionIndex === undefined || choiceIndex === undefined) return null;
        const option = product.foodOptionsTypeList[optionIndex];
        const choice = option?.foodOptionsList[choiceIndex];
        const isInvalidAdditionalPrice = !choice || choice.price < 0;

        const shouldShowError =
          submitBtnClick && isInvalidAdditionalPrice && !option.isNew;

        return shouldShowError ? (
          <ErrorText>Please enter valid Additional Price.</ErrorText>
        ) : null;
      }
      default:
        return null;
    }
  };

  const callbackFullDesc = (value: any) => {
    let temp = { ...product };
    temp.description = validateTextInput(value, 300);
    setProduct(temp);
  };

  const callbackName = (value: any) => {
    let temp = { ...product };
    temp.item = validateTextInput(value, 150);
    setProduct(temp);
  };

  const callBackDropdownCategories = async (value: any) => {
    let temp = { ...product };
    temp.categories = value;
    setProduct(temp);
  };

  const ImageWrapper = () => {
    return (
      <>
        <CustomImageUpload
          titleEN="Product Photos"
          titleCN="产品图片"
          data={images}
          noOfImage={1}
          maxNumber={maxNumber}
          isRequired={true}
          callback={(value: any) => valueChangedProductPhotos(value)}
          productId={product.id || -1}
        />
        {submitBtnClick && showMessage("photoPath")}
      </>
    );
  };

  const handleAvailabilityToggle = () => {
    setProduct({
      ...product,
      isAvailable: !product.isAvailable,
    });
  };

  const handleEighteenPlusToggle = () => {
    setProduct({
      ...product,
      isEighteenPlus: !product.isEighteenPlus,
    });
  };

  // Review Modal Helper Functions
  const getReviewImages = (): string[] => {
    const reviewImages: string[] = [];

    // Get images from the images state
    if (images && images.length > 0) {
      images.forEach((img) => {
        if (img.photoPath) {
          reviewImages.push(img.photoPath);
        }
      });
    }

    // Fallback to product photoPath if available
    if (product.photoPath && !reviewImages.includes(product.photoPath)) {
      reviewImages.push(product.photoPath);
    }

    return reviewImages.filter((img) => img && img.trim() !== "");
  };

  const getReviewCategoryName = () => {
    if (!product.categories || product.categories.length === 0) {
      return "Uncategorized";
    }
    return product.categories[0]?.name || "Main Course";
  };

  const handleCreateFromReview = async () => {
    setIsCreatingFromReview(true);
    await createFoodMenu();
    setIsCreatingFromReview(false);
    setShowReviewModal(false);
  };

  const handleCloseReview = () => {
    setShowReviewModal(false);
  };

  const formatTimeInput = (input: string) => {
    // Remove all non-digit characters
    const digits = input.replace(/\D/g, "");

    // Limit to 4 digits maximum
    const limitedDigits = digits.slice(0, 4);

    if (limitedDigits.length === 0) {
      return "";
    }

    if (limitedDigits.length <= 2) {
      // For 1-2 digits, just return as is (hour input)
      return limitedDigits;
    } else {
      // For 3-4 digits, format as HH:MM
      const hours = limitedDigits.slice(0, 2);
      const minutes = limitedDigits.slice(2, 4);

      // Validate hours (00-23)
      const hourNum = parseInt(hours, 10);
      if (hourNum > 23) {
        return limitedDigits.slice(0, 2); // Return just valid hours
      }

      // Validate minutes (00-59)
      const minuteNum = parseInt(minutes, 10);
      if (minuteNum > 59) {
        return `${hours}:${minutes.slice(0, 1)}`; // Return with partial minutes
      }

      return `${hours}:${minutes}`;
    }
  };

  const handleTimeInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedTime = formatTimeInput(e.target.value);
    setProduct({ ...product, estPreparationTime: formattedTime });
  };

  const toggleHelperText = (field: string) => {
    setHelperTextVisible((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const hideAllHelperText = () => {
    setHelperTextVisible((prev) =>
      Object.keys(prev).reduce(
        (acc, key) => ({ ...acc, [key]: false }),
        {} as typeof prev
      )
    );
  };

  // Close helper text when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest(".help-icon-container")) {
        hideAllHelperText();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <>
      {loading && (
        <LoadingOverlay>
          <LoadingSpinner>
            <LoadingSpinnerIcon />
          </LoadingSpinner>
        </LoadingOverlay>
      )}

      {(id === "-1" || (id !== "-1" && refreshFlag)) && (
        <Box
          sx={{
            bgcolor: "#FFFFFF",
            maxWidth: "100%",
            padding: { xs: "8px", sm: "16px 44px" },
            marginBottom: "15px",
            overflow: "hidden",
          }}
        >
          <PageHeader>
            {id === "-1" && (
              <PageTitle>
                <LanguageText>Add Food Item </LanguageText>
              </PageTitle>
            )}
            {id !== "-1" && (
              <PageTitle>
                <LanguageText>Edit Food Menu</LanguageText>
              </PageTitle>
            )}
          </PageHeader>
          <FormContainer>
            <FormRow>
              <FormLabel>
                <div>
                  <LanguageText className="f-16 fw-700 primary-color">
                    Item Photo*
                  </LanguageText>
                  <HelpIcon
                    sx={{
                      fontSize: "24px",
                      color: "#CCCCCC",
                      cursor: "pointer",
                      ml: 0.5,
                    }}
                  />
                </div>
              </FormLabel>
              <FormField>
                <div className="mb-16">{ImageWrapper()}</div>
              </FormField>
            </FormRow>

            <FormRow>
              <FormLabel>
                <div>
                  <LanguageText className="f-16 fw-700 primary-color">
                    Item Name*
                  </LanguageText>
                  <HelpIconContainer
                    className="help-icon-container"
                    onClick={() => toggleHelperText("foodName")}
                  >
                    <HelpIcon
                      sx={{
                        fontSize: "24px",
                        color: "#CCCCCC",
                        cursor: "pointer",
                        ml: 0.5,
                      }}
                    />
                    {helperTextVisible.foodName && (
                      <HelperTextPopup $visible={helperTextVisible.foodName}>
                        <HelperTextContent>
                          Enter a clear and appealing name for your menu item
                          that customers will recognize.
                        </HelperTextContent>
                      </HelperTextPopup>
                    )}
                  </HelpIconContainer>
                </div>
                <div>
                  <span className="f-14 fw-400 color-8C8C8C">(Max. 120)</span>
                </div>
              </FormLabel>
              <FormField>
                <CustomTextField
                  titleEN="Name"
                  titleCN="姓名"
                  value={product.item}
                  patternType="text"
                  isRequired={true}
                  minLength={0}
                  maxLength={150}
                  width={680}
                  height={56}
                  fontSize={16}
                  fontWeight={700}
                  color="#1E2F23"
                  borderColor="#E39435"
                  labelColor="#B0B0B0"
                  labelFontWeight={400}
                  placeholder="Enter Item Name, Max 120 Characters"
                  callback={(value: any) => callbackName(value)}
                />
                {submitBtnClick && showMessage("item")}
              </FormField>
            </FormRow>

            <FormRow>
              <FormLabel>
                <div>
                  <LanguageText className="f-16 fw-700 primary-color">
                    Item Description
                  </LanguageText>
                  <HelpIconContainer
                    className="help-icon-container"
                    onClick={() => toggleHelperText("foodDescription")}
                  >
                    <HelpIcon
                      sx={{
                        fontSize: "24px",
                        color: "#CCCCCC",
                        cursor: "pointer",
                        ml: 0.5,
                      }}
                    />
                    {helperTextVisible.foodDescription && (
                      <HelperTextPopup
                        $visible={helperTextVisible.foodDescription}
                      >
                        <HelperTextContent>
                          Add a brief description to help customers understand
                          what this menu item includes.
                        </HelperTextContent>
                      </HelperTextPopup>
                    )}
                  </HelpIconContainer>
                </div>
                <div>
                  <span className="f-14 fw-400 color-8C8C8C">(Max. 300)</span>
                </div>
              </FormLabel>
              <FormField>
                <CustomTextArea
                  titleEN="Item description"
                  titleCN="Item description"
                  value={product.description}
                  placeholder="Enter Item Description, Max 300 Characters"
                  patternType="text"
                  isRequired={true}
                  width="680px"
                  borderColor="#E39435"
                  minLength={0}
                  maxLength={300}
                  fontSize={16}
                  fontWeight={700}
                  color="#1E2F23"
                  labelColor="#B0B0B0"
                  labelFontSize={16}
                  labelFontWeight={400}
                  callback={(value: any) => callbackFullDesc(value)}
                />
                {submitBtnClick && showMessage("description")}
              </FormField>
            </FormRow>

            <FormRow>
              <FormLabel>
                <div>
                  <LanguageText className="f-16 fw-700 primary-color">
                    Item Category*
                  </LanguageText>
                  <HelpIconContainer
                    className="help-icon-container"
                    onClick={() => toggleHelperText("foodCategory")}
                  >
                    <HelpIcon
                      sx={{
                        fontSize: "24px",
                        color: "#CCCCCC",
                        cursor: "pointer",
                        ml: 0.5,
                      }}
                    />
                    {helperTextVisible.foodCategory && (
                      <HelperTextPopup
                        $visible={helperTextVisible.foodCategory}
                      >
                        <HelperTextContent>
                          Select the appropriate category for your menu item to
                          help customers find it easily.
                        </HelperTextContent>
                      </HelperTextPopup>
                    )}
                  </HelpIconContainer>
                </div>
              </FormLabel>
              <FormField>
                <MultiSelectWithSearch
                  data={categories}
                  placeHolder="Search and select category"
                  borderColor="#E39435"
                  arrowColor="green"
                  menuItemColor="#1E2F23"
                  id="id"
                  value="name"
                  width={680}
                  height={56}
                  labelFontSize={16}
                  labelFontWeight={400}
                  labelColor="#B0B0B0"
                  default={product.categories}
                  canRemove={true}
                  callback={(selected: any) =>
                    callBackDropdownCategories(selected)
                  }
                />
                {submitBtnClick && showMessage("categories")}
              </FormField>
            </FormRow>
            <br></br>

            <FormRow>
              <FormLabel>
                <div>
                  <span className="f-16 fw-700 primary-color">
                    <LanguageText className="f-16 fw-700 primary-color">
                      Item Price (SGD)*
                    </LanguageText>
                    <HelpIconContainer
                      className="help-icon-container"
                      onClick={() => toggleHelperText("foodPrice")}
                    >
                      <HelpIcon
                        sx={{
                          fontSize: "24px",
                          color: "#CCCCCC",
                          cursor: "pointer",
                          ml: 0.5,
                        }}
                      />
                      {helperTextVisible.foodPrice && (
                        <HelperTextPopup $visible={helperTextVisible.foodPrice}>
                          <HelperTextContent>
                            Set the base price for your menu item in Singapore
                            Dollars.
                          </HelperTextContent>
                        </HelperTextPopup>
                      )}
                    </HelpIconContainer>
                  </span>
                </div>
              </FormLabel>
              <FormField>
                <CustomNumberField
                  titleEN="Price(SGD)"
                  titleCN="价格中文(SGD)"
                  value={product.price}
                  placeholder="Enter Item Price, max 2 decimal places"
                  isRequired={true}
                  min={0}
                  max={9999999.99}
                  decimalPlaces={2}
                  width={680}
                  height={56}
                  fontSize={16}
                  fontWeight={700}
                  color="#1E2F23"
                  borderColor="#E39435"
                  callback={(value: string) => callbackPrice(value)}
                />
                {submitBtnClick && showMessage("price")}
              </FormField>
            </FormRow>

            <FormRow>
              <FormLabel>
                <div>
                  <span className="f-16 fw-700 primary-color">
                    <LanguageText className="f-16 fw-700 primary-color">
                      Item Est. Preparation Time
                    </LanguageText>
                    <HelpIconContainer
                      className="help-icon-container"
                      onClick={() => toggleHelperText("preparationTime")}
                    >
                      <HelpIcon
                        sx={{
                          fontSize: "24px",
                          color: "#CCCCCC",
                          cursor: "pointer",
                        }}
                      />
                      {helperTextVisible.preparationTime && (
                        <HelperTextPopup
                          $visible={helperTextVisible.preparationTime}
                        >
                          <HelperTextContent>
                            Enter the estimated time needed to prepare this menu
                            item.
                          </HelperTextContent>
                        </HelperTextPopup>
                      )}
                    </HelpIconContainer>
                  </span>
                </div>
              </FormLabel>
              <FormField>
                <TimeInputField
                  type="text"
                  value={product.estPreparationTime}
                  onChange={handleTimeInputChange}
                  placeholder="00:00"
                  maxLength={5}
                />
              </FormField>
            </FormRow>
            <br></br>

            {/* Availability Toggle */}
            <FormRow>
              <FormLabel>
                <div>
                  <LanguageText className="f-16 fw-700 primary-color">
                    Menu Available*
                  </LanguageText>
                  <HelpIconContainer
                    className="help-icon-container"
                    onClick={() => toggleHelperText("menuAvailable")}
                  >
                    <HelpIcon
                      sx={{
                        fontSize: "24px",
                        color: "#CCCCCC",
                        cursor: "pointer",
                        ml: 0.5,
                      }}
                    />
                    {helperTextVisible.menuAvailable && (
                      <HelperTextPopup
                        $visible={helperTextVisible.menuAvailable}
                      >
                        <HelperTextContent>
                          Toggle this to control whether the menu item is
                          available for ordering.
                        </HelperTextContent>
                      </HelperTextPopup>
                    )}
                  </HelpIconContainer>
                </div>
              </FormLabel>
              <FormField>
                <AvailabilityToggleContainer>
                  <ToggleSwitch>
                    <ToggleInput
                      type="checkbox"
                      checked={product.isAvailable}
                      onChange={handleAvailabilityToggle}
                    />
                    <ToggleSlider />
                  </ToggleSwitch>
                  <ToggleLabel>
                    {/* {product.isAvailable ? "Available" : "Unavailable"} */}
                  </ToggleLabel>
                </AvailabilityToggleContainer>
              </FormField>
            </FormRow>
            <br></br>

            <FormRow>
              <FormLabel>
                <div>
                  <LanguageText className="f-16 fw-700 primary-color">
                    18+ Item
                  </LanguageText>
                  <HelpIconContainer
                    className="help-icon-container"
                    onClick={() => toggleHelperText("eighteenPlus")}
                  >
                    <HelpIcon
                      sx={{
                        fontSize: "24px",
                        color: "#CCCCCC",
                        cursor: "pointer",
                        ml: 0.5,
                      }}
                    />
                    {helperTextVisible.eighteenPlus && (
                      <HelperTextPopup
                        $visible={helperTextVisible.eighteenPlus}
                      >
                        <HelperTextContent>
                          Enable this if the menu item is only available for
                          customers 18 years and older.
                        </HelperTextContent>
                      </HelperTextPopup>
                    )}
                  </HelpIconContainer>
                </div>
              </FormLabel>
              <FormField>
                <AvailabilityToggleContainer>
                  <ToggleSwitch>
                    <ToggleInput
                      type="checkbox"
                      checked={product.isEighteenPlus}
                      onChange={handleEighteenPlusToggle}
                    />
                    <ToggleSlider />
                  </ToggleSwitch>
                  <ToggleLabel>
                    {/* {product.isEighteenPlus
                      ? "18+ Avilable"
                      : "18+ Unavailable"} */}
                  </ToggleLabel>
                </AvailabilityToggleContainer>
              </FormField>
            </FormRow>
            <br></br>
          </FormContainer>

          <ProductDivider className="mb-32"></ProductDivider>

          <Row className="mb-32">
            <Col xl={6} lg={6} md={6} sm={12} className="mb-8">
              <span className="mr-32">
                <span className="f-24 fw-700 primary-color mr-8">
                  {product?.foodOptionsTypeList.length}
                </span>

                <LanguageText className="f-16 fw-500">
                  options added
                </LanguageText>
              </span>
            </Col>
            <Col xl={6} lg={6} md={6} sm={12}>
              <AddOptionsButton onClick={addNewFoodOption}>
                <AddIcon sx={{ fontSize: 24 }} />
                <LanguageText className="f-16 fw-700">Option</LanguageText>
              </AddOptionsButton>
            </Col>
          </Row>

          {product?.foodOptionsTypeList &&
            product?.foodOptionsTypeList.length > 0 &&
            product?.foodOptionsTypeList.map(
              (option: any, optionInd: number) => (
                <React.Fragment key={`option-${optionInd}`}>
                  <div>
                    <div className="flex space-between mb-32">
                      <div className="f-18 fw-700 primary-color mr-32 crop_text_cart_300">
                        {optionInd + 1}. {option.name || "New Food Option"}
                      </div>
                      <div
                        className="primary-color pointer permanent-flex"
                        onClick={() => deleteOption(option)}
                      >
                        <DeleteOutlinedIcon sx={{ fontSize: "24px" }} />
                        <span className="f-18 fw-400 primary-color">
                          Delete option
                        </span>
                      </div>
                    </div>

                    <Row>
                      <Col xl={6} lg={6} md={6} sm={12} className="mb-16">
                        <div className="mb-8">
                          <LanguageText className="f-16 fw-700 primary-color">
                            Option Title*
                          </LanguageText>
                          <HelpIconContainer
                            className="help-icon-container"
                            onClick={() =>
                              toggleHelperText(`optionName_${optionInd}`)
                            }
                          >
                            <HelpIcon
                              sx={{
                                fontSize: "24px",
                                color: "#CCCCCC",
                                cursor: "pointer",
                              }}
                            />
                            {helperTextVisible[`optionName_${optionInd}`] && (
                              <HelperTextPopup
                                $visible={
                                  helperTextVisible[`optionName_${optionInd}`]
                                }
                              >
                                <HelperTextContent>
                                  Enter a name for this option group (e.g.,
                                  "Size", "Toppings").
                                </HelperTextContent>
                              </HelperTextPopup>
                            )}
                          </HelpIconContainer>
                        </div>
                        <CustomTextField
                          titleEN="Enter Option Name, Max 120 Characters"
                          titleCN="Enter Option Name, Max 120 Characters"
                          value={option.name}
                          patternType="text"
                          isRequired={true}
                          minLength={0}
                          maxLength={100}
                          height={56}
                          fontSize={16}
                          fontWeight={700}
                          color="#1E2F23"
                          borderColor="#E39435"
                          callback={(value: any) =>
                            callbackOptionName(value, option)
                          }
                        />
                        {/* Show validation only for this specific option */}
                        {showMessage("optionName", optionInd)}
                      </Col>

                      <Col xl={6} lg={6} md={6} sm={12} className="mb-16">
                        <div className="mb-8">
                          <LanguageText className="f-16 fw-700 primary-color">
                            Option Description
                          </LanguageText>
                          <HelpIconContainer
                            className="help-icon-container"
                            onClick={() =>
                              toggleHelperText(`optionDescription_${optionInd}`)
                            }
                          >
                            <HelpIcon
                              sx={{
                                fontSize: "24px",
                                color: "#CCCCCC",
                                cursor: "pointer",
                              }}
                            />
                            {helperTextVisible[
                              `optionDescription_${optionInd}`
                            ] && (
                              <HelperTextPopup
                                $visible={
                                  helperTextVisible[
                                    `optionDescription_${optionInd}`
                                  ]
                                }
                              >
                                <HelperTextContent>
                                  Enter a description for this option group.
                                </HelperTextContent>
                              </HelperTextPopup>
                            )}
                          </HelpIconContainer>
                        </div>
                        <CustomTextField
                          titleEN="Enter Option Description, Max 300 Characters"
                          titleCN="Enter Option Description, Max 300 Characters"
                          value={option?.description}
                          patternType="text"
                          isRequired={true}
                          minLength={0}
                          maxLength={300}
                          height={56}
                          fontSize={16}
                          fontWeight={700}
                          color="#1E2F23"
                          borderColor="#E39435"
                          callback={(value: any) =>
                            callbackOptionDescription(value, option)
                          }
                        />
                        {showMessage("optionDescription", optionInd)}
                      </Col>

                      <Col xl={6} lg={6} md={6} sm={12} className="mb-16">
                        <div className="mb-8">
                          <LanguageText className="f-16 fw-700 primary-color">
                            Min. Choice*
                          </LanguageText>
                          <HelpIconContainer
                            className="help-icon-container"
                            onClick={() =>
                              toggleHelperText(`minSelection_${optionInd}`)
                            }
                          >
                            <HelpIcon
                              sx={{
                                fontSize: "24px",
                                color: "#CCCCCC",
                                cursor: "pointer",
                              }}
                            />
                            {helperTextVisible[`minSelection_${optionInd}`] && (
                              <HelperTextPopup
                                $visible={
                                  helperTextVisible[`minSelection_${optionInd}`]
                                }
                              >
                                <HelperTextContent>
                                  Set the minimum number of items customers can
                                  select from this option group.
                                </HelperTextContent>
                              </HelperTextPopup>
                            )}
                          </HelpIconContainer>
                        </div>
                        <CustomQtyField
                          inputMode="decimal"
                          titleEN="Min. Choice"
                          titleCN="Min. Choice"
                          value={option?.minCount}
                          min={0}
                          max={50}
                          decimalPlaces={0}
                          isRequired={true}
                          width={680}
                          height={56}
                          fontSize={16}
                          fontWeight={700}
                          color="#1E2F23"
                          borderColor="#E39435"
                          callback={(value: string) => {
                            const numValue = parseInt(value) || 0;
                            callbackOptionMinCount(numValue, option);
                          }}
                        />
                        {showMessage("optionMin", optionInd)}
                      </Col>

                      <Col xl={6} lg={6} md={6} sm={12} className="mb-16">
                        <div className="mb-8">
                          <LanguageText className="f-16 fw-700 primary-color">
                            Max. Choice*
                          </LanguageText>
                          <HelpIconContainer
                            className="help-icon-container"
                            onClick={() =>
                              toggleHelperText(`maxSelection_${optionInd}`)
                            }
                          >
                            <HelpIcon
                              sx={{
                                fontSize: "24px",
                                color: "#CCCCCC",
                                cursor: "pointer",
                              }}
                            />
                            {helperTextVisible[`maxSelection_${optionInd}`] && (
                              <HelperTextPopup
                                $visible={
                                  helperTextVisible[`maxSelection_${optionInd}`]
                                }
                              >
                                <HelperTextContent>
                                  Set the maximum number of items customers can
                                  select from this option group.
                                </HelperTextContent>
                              </HelperTextPopup>
                            )}
                          </HelpIconContainer>
                        </div>
                        <CustomQtyField
                          inputMode="decimal"
                          titleEN="Max. Choice"
                          titleCN="Max. Choice"
                          value={option?.maxCount}
                          min={0}
                          max={50}
                          isRequired={true}
                          height={56}
                          fontSize={16}
                          fontWeight={700}
                          color="#1E2F23"
                          borderColor="#E39435"
                          callback={(value: any) =>
                            callbackOptionMaxCount(value, option)
                          }
                        />
                        {showMessage("optionMax", optionInd)}
                      </Col>
                    </Row>

                    <AddSubOptionsButton
                      onClick={() => handleAddFoodOption(option)}
                      className="mb-16"
                    >
                      <AddIcon sx={{ fontSize: 24 }} />
                      <LanguageText className="no-wrap">Choice</LanguageText>
                    </AddSubOptionsButton>

                    {showMessage("choiceLength", optionInd)}

                    {option?.foodOptionsList &&
                      option?.foodOptionsList.length > 0 &&
                      option?.foodOptionsList.map(
                        (foodOption: any, choiceIndex: number) => (
                          <div key={`food-option-${option.id}-${choiceIndex}`}>
                            <Row>
                              <Col
                                xl={3}
                                lg={4}
                                md={4}
                                sm={12}
                                className="mb-8"
                              >
                                <div className="mb-8">
                                  <span className="f-14 fw-700 primary-color border-none">
                                    Choice Name*
                                  </span>
                                  <HelpIconContainer
                                    className="help-icon-container"
                                    onClick={() =>
                                      toggleHelperText(
                                        `choiceName_${optionInd}_${choiceIndex}`
                                      )
                                    }
                                  >
                                    <HelpIcon
                                      sx={{
                                        fontSize: "24px",
                                        color: "#CCCCCC",
                                        cursor: "pointer",
                                        ml: 0.5,
                                      }}
                                    />
                                    {helperTextVisible[
                                      `choiceName_${optionInd}_${choiceIndex}`
                                    ] && (
                                      <HelperTextPopup
                                        $visible={
                                          helperTextVisible[
                                            `choiceName_${optionInd}_${choiceIndex}`
                                          ]
                                        }
                                      >
                                        <HelperTextContent>
                                          Enter a name for this choice (e.g.,
                                          "Small", "Medium", "Large").
                                        </HelperTextContent>
                                      </HelperTextPopup>
                                    )}
                                  </HelpIconContainer>
                                </div>
                                <FoodOptionInput
                                  type="text"
                                  placeholder="Enter Choice Name, Max 150 Characters"
                                  height={44}
                                  maxLength={150}
                                  value={foodOption.name}
                                  onChange={(value: any) =>
                                    handleOptionChange(
                                      option,
                                      choiceIndex,
                                      "name",
                                      value
                                    )
                                  }
                                />
                                {/* Show validation only for this specific choice */}
                                {showMessage(
                                  "choiceName",
                                  optionInd,
                                  choiceIndex
                                )}
                              </Col>

                              <Col
                                xl={3}
                                lg={4}
                                md={4}
                                sm={12}
                                className="mb-8"
                              >
                                <div className="mb-8">
                                  <span className="f-14 fw-700 primary-color border-none">
                                    Additional Price (SGD)*
                                  </span>
                                  <HelpIconContainer
                                    className="help-icon-container"
                                    onClick={() =>
                                      toggleHelperText(
                                        `additionalPrice_${optionInd}_${choiceIndex}`
                                      )
                                    }
                                  >
                                    <HelpIcon
                                      sx={{
                                        fontSize: "24px",
                                        color: "#CCCCCC",
                                        cursor: "pointer",
                                        ml: 0.5,
                                      }}
                                    />
                                    {helperTextVisible[
                                      `additionalPrice_${optionInd}_${choiceIndex}`
                                    ] && (
                                      <HelperTextPopup
                                        $visible={
                                          helperTextVisible[
                                            `additionalPrice_${optionInd}_${choiceIndex}`
                                          ]
                                        }
                                      >
                                        <HelperTextContent>
                                          Enter the additional price for this
                                          choice.
                                        </HelperTextContent>
                                      </HelperTextPopup>
                                    )}
                                  </HelpIconContainer>
                                </div>
                                <FoodOptionInput
                                  type="number"
                                  placeholder="Price"
                                  height={44}
                                  value={foodOption.price}
                                  onChange={(value: any) => {
                                    if (!/^\d*\.?\d{0,2}$/.test(value)) {
                                      return;
                                    }
                                    handleOptionChange(
                                      option,
                                      choiceIndex,
                                      "price",
                                      parseFloat(value)
                                    );
                                  }}
                                />
                                {showMessage(
                                  "choiceAdditionalprice",
                                  optionInd,
                                  choiceIndex
                                )}
                              </Col>

                              <Col
                                xl={3}
                                lg={4}
                                md={4}
                                sm={12}
                                className="mb-8"
                              >
                                <div className="mb-8">
                                  <LanguageText className="f-14 fw-700 primary-color border-none">
                                    Total Price (SGD)*
                                  </LanguageText>
                                  <HelpIconContainer
                                    className="help-icon-container"
                                    onClick={() =>
                                      toggleHelperText(
                                        `totalPrice_${optionInd}_${choiceIndex}`
                                      )
                                    }
                                  >
                                    <HelpIcon
                                      sx={{
                                        fontSize: "24px",
                                        color: "#CCCCCC",
                                        cursor: "pointer",
                                        ml: 0.5,
                                      }}
                                    />
                                    {helperTextVisible[
                                      `totalPrice_${optionInd}_${choiceIndex}`
                                    ] && (
                                      <HelperTextPopup
                                        $visible={
                                          helperTextVisible[
                                            `totalPrice_${optionInd}_${choiceIndex}`
                                          ]
                                        }
                                      >
                                        <HelperTextContent>
                                          The total price is automatically
                                          calculated by adding the base price
                                          and additional price.
                                        </HelperTextContent>
                                      </HelperTextPopup>
                                    )}
                                  </HelpIconContainer>
                                </div>
                                <PriceDisplayBox>
                                  {(product.price + foodOption.price).toFixed(
                                    2
                                  )}
                                </PriceDisplayBox>
                              </Col>

                              <Col
                                xl={3}
                                lg={4}
                                md={4}
                                sm={12}
                                className="mb-8"
                              >
                                <div className="mb-8">
                                  <span className="f-14 fw-700 primary-color border-none">
                                    Quantity
                                  </span>
                                </div>
                                <FoodOptionInput
                                  type="text"
                                  placeholder="Qty"
                                  height={44}
                                  value={foodOption.qty}
                                  onChange={(value: any) =>
                                    handleOptionChange(
                                      option,
                                      choiceIndex,
                                      "qty",
                                      value && value !== ""
                                        ? parseFloat(value)
                                        : 0
                                    )
                                  }
                                />
                                {showMessage(
                                  "choiceQty",
                                  optionInd,
                                  choiceIndex
                                )}
                              </Col>

                              <Col
                                xl={3}
                                lg={4}
                                md={4}
                                sm={12}
                                className="mb-8"
                              >
                                <div className="mb-8">
                                  <span className="f-14 fw-700 primary-color border-none">
                                    Unit
                                  </span>
                                </div>
                                <FoodOptionInput
                                  type="text"
                                  placeholder="Unit"
                                  height={44}
                                  value={foodOption.unit}
                                  onChange={(value: any) =>
                                    handleOptionChange(
                                      option,
                                      choiceIndex,
                                      "unit",
                                      value
                                    )
                                  }
                                />
                                {/* Show qty/unit validation for this specific choice */}
                                {showMessage(
                                  "choiceUnit",
                                  optionInd,
                                  choiceIndex
                                )}
                              </Col>

                              <Col
                                xl={3}
                                lg={4}
                                md={4}
                                sm={12}
                                className="mb-8"
                              >
                                <div className="flex mt-42">
                                  <span
                                    className="pointer primary-color flex"
                                    onClick={() =>
                                      handleRemoveOption(option, choiceIndex)
                                    }
                                  >
                                    <DeleteOutlinedIcon
                                      sx={{ fontSize: "24px" }}
                                    />
                                    <LanguageText>Delete</LanguageText>
                                  </span>
                                </div>
                              </Col>
                            </Row>
                            {choiceIndex !==
                              option?.foodOptionsList.length - 1 && (
                              <div
                                key={`choice-divider-${option.id}-${choiceIndex}`}
                                className="choice-divider mb-32"
                              ></div>
                            )}
                          </div>
                        )
                      )}
                  </div>
                  {optionInd !== product?.foodOptionsTypeList.length - 1 && (
                    <OptionDivider className="mt-32 mb-32"></OptionDivider>
                  )}
                </React.Fragment>
              )
            )}

          <ProductDivider className="mt-32 mb-32"></ProductDivider>
          <ActionButtons>
            <SendButton onClick={cancel}>
              <LanguageText>Back</LanguageText>
            </SendButton>
            <ResponsiveButtonContainer>
              {/* {id !== "-1" && (
                <SendButton className="mr-16 mb-8">
                  <LanguageText>Delete</LanguageText>
                </SendButton>
              )} */}

              <SendButtonActive onClick={submit}>
                <LanguageText>
                  <LanguageText>
                    {loading
                      ? "Saving..."
                      : id !== "-1"
                      ? "Update Food Menu"
                      : "Create Food Menu"}
                  </LanguageText>
                </LanguageText>
              </SendButtonActive>
            </ResponsiveButtonContainer>
          </ActionButtons>
        </Box>
      )}

      {/* Review Modal */}
      {showReviewModal && (
        <ReviewModalOverlay onClick={handleCloseReview}>
          <ReviewModalContent onClick={(e) => e.stopPropagation()}>
            <ReviewModalHeader>
              <ReviewModalTitle>Review Item</ReviewModalTitle>
              <ReviewModalCloseButton onClick={handleCloseReview}>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 6L6 18M6 6L18 18"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </ReviewModalCloseButton>
            </ReviewModalHeader>

            <ReviewModalBody>
              {/* Image Preview */}
              <ReviewImageContainer>
                {getReviewImages().length > 0 ? (
                  <ReviewImage
                    src={getReviewImages()[0]}
                    alt={product.item}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = "none";
                    }}
                  />
                ) : (
                  <ReviewImagePlaceholder>
                    No images uploaded
                  </ReviewImagePlaceholder>
                )}
              </ReviewImageContainer>

              {/* Item Details */}
              <ReviewItemDetails>
                <ReviewItemName className="">
                  {product.item || "Untitled Item"}
                </ReviewItemName>
                <ReviewItemPrice>
                  ${product.price?.toFixed(2) || "0.00"}
                </ReviewItemPrice>

                {product.description && (
                  <ReviewItemDescription>
                    {product.description}
                  </ReviewItemDescription>
                )}

                <ReviewCategoryTag>{getReviewCategoryName()}</ReviewCategoryTag>

                {product.foodOptionsTypeList &&
                  product.foodOptionsTypeList.length > 0 && (
                    <ReviewOptionsSection>
                      <ReviewOptionsTitle>Available Options</ReviewOptionsTitle>
                      {product.foodOptionsTypeList.map(
                        (group: any, index: number) => (
                          <ReviewOptionGroup key={index}>
                            <ReviewOptionGroupName>
                              {group.name}:
                            </ReviewOptionGroupName>{" "}
                            <ReviewOptionGroupOptions>
                              {group.foodOptionsList
                                ?.map((option: any) => option.name)
                                .join(", ") || "None"}
                            </ReviewOptionGroupOptions>
                          </ReviewOptionGroup>
                        )
                      )}
                    </ReviewOptionsSection>
                  )}
              </ReviewItemDetails>
            </ReviewModalBody>

            <ReviewModalActions>
              <ReviewModalButton
                $variant="secondary"
                onClick={handleCloseReview}
              >
                Cancel
              </ReviewModalButton>
              <ReviewModalButton
                $variant="primary"
                onClick={handleCreateFromReview}
                disabled={isCreatingFromReview}
              >
                {isCreatingFromReview && <ReviewLoadingSpinner />}
                {id === "-1" && (
                  <span>
                    {isCreatingFromReview ? "Creating..." : "Create Item"}
                  </span>
                )}
                {id !== "-1" && (
                  <span>
                    {isCreatingFromReview ? "Updating..." : "Update Item"}
                  </span>
                )}
              </ReviewModalButton>
            </ReviewModalActions>
          </ReviewModalContent>
        </ReviewModalOverlay>
      )}
    </>
  );
};

export default FoodEntry;
